import React from "react";
import wave from "../../../Assets/Images/competitions/wave.png";
import gamify_Self_Learning from "../../../Assets/Images/competitions/gamify_Self_Learning.svg";
import continuous_improvment from "../../../Assets/Images/competitions/continuous_improvment.svg";
import periodic_assesment from "../../../Assets/Images/competitions/periodic_assesment.svg";
import boost_self_confidence from "../../../Assets/Images/competitions/boost_self_confidence.svg";
import low_screentime from "../../../Assets/Images/competitions/low_screentime.svg";
import personalised_goal from "../../../Assets/Images/competitions/personalised_goal.svg";
import "./style.css";

const ChildHelps = () => {
  return (
    <div className="narcBenifit">
      <div
        className="sectionBlock"
        style={{
          backgroundImage: wave,
        }}
      >
        <div className="block">
          <div className="img">
            <img src={gamify_Self_Learning} alt="  Gamifies Self Learning" />
          </div>
          <div className="text"> Gamifies Self Learning</div>
        </div>
        <div className="block">
          <div className="img">
            <img
              src={continuous_improvment}
              alt="Enables Continuous Improvement"
            />
          </div>
          <div className="text">Enables Continuous Improvement</div>
        </div>
        <div className="block">
          <div className="img">
            <img
              src={periodic_assesment}
              alt="Helps attain new heights though Periodic Assessments"
            />
          </div>
          <div className="text">
            Provides Periodic
            <br /> Assessments
          </div>
        </div>
        <div className="block">
          <div className="img">
            <img src={boost_self_confidence} alt="Boosts Self Confidence" />
          </div>
          <div className="text">
            Boosts Self
            <br /> Confidence
          </div>
        </div>
        <div className="block">
          <div className="img">
            <img
              src={personalised_goal}
              alt="Personalized learning goals for every age"
            />
          </div>
          <div className="text">
            Prioritizes Personalized <br />
            Learning Goals{" "}
          </div>
        </div>
        <div className="block">
          <div className="img">
            <img
              src={low_screentime}
              alt="Provides countless hours of entertainment with low screen time"
            />
          </div>
          <div className="text">
            Solves for
            <br /> Low Screen Time
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildHelps;
